export type PaddingState = {
  above?: number;
  below?: number;
};
